import React, { lazy, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'semantic-ui-react';
import * as R from 'ramda';
import moment from 'moment';

import { history } from 'init/history';
import { promisifyAction } from 'helpers/promisifyAction';
import { LANGS_BY_LOCALE } from 'localization/constants';

import { getOtpuskToken } from 'bus/auth/selectors';
import { tourscanerActions } from 'bus/tourscaner/actions';

import { getCrmTypes } from 'crms/utils';
import { getTourscannerThemeColor } from 'crms/helpers';

import { Header } from 'components/parts/Header';
import Footer from 'components/parts/Footer';

import book from '../../routes/book';

import { initialize } from './store/actions';
import { getIsCompleted, getIsLoading, getLocale, getCurrency } from './store/selectors';

const Tourscanner = lazy(() => import('@otpusk/tourscaner'));

const PublicOfferPage = () => {
  const { is5Stars, isMt, isTat } = getCrmTypes();
  const isLoading = useSelector(getIsLoading);
  const isCompleted = useSelector(getIsCompleted);
  const locale = useSelector(getLocale);
  const currency = useSelector(getCurrency);
  const otpuskToken = useSelector(getOtpuskToken);

  const dispatch = useDispatch();

  const THEM_COLOR = getTourscannerThemeColor();

  const tsConfig = useMemo(() => ({
    apiKey: otpuskToken,
    lang: LANGS_BY_LOCALE[locale],
    theme: {
      button: {
        background: THEM_COLOR,
      },
      primaryColor: THEM_COLOR,
    },
    callbacks: {
      onGetBookingOperators: () => [],
      onShowOffer: ({ hotel, offer, callSource = 'modal' }) => {
        if (callSource === 'page') {
          document.title = `${hotel.name} ${hotel.stars}* ${moment(offer.date).format('DD MMMM')}`;
        }
      },
      onGetSimilarHotels: promisifyAction(
        (...args) => dispatch(tourscanerActions.getSimilarHotels(...args))
      ),
    },
    google_maps_api_key: __DEV__
      ? 'AIzaSyBy90l2W4L7hU44f9WO2v_q339C3-vfGn4'
      : R.cond([
        [R.equals(isMt), R.always('AIzaSyCMMAnV6inu7L9C03pHxim3oDP4czed_Bg')],
        [R.equals(isTat), R.always('AIzaSyCWoPw6TDNp-vwJxHc6YpAzCE3BLbVhIko')],
        [R.equals(is5Stars), R.always('AIzaSyBt9igxHtUaPitqYFBmdLCzuLKTUb6Vwrc')]
      ])(true),
    settings: {
      INITIAL_CURRENCY_CODE: currency,
      MODE: 'tourist',
    },
    basePath: book.tourscanner.path,
    browserHistory: history
  }), [THEM_COLOR, currency, is5Stars, isMt, isTat, locale, otpuskToken]);

  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);

  return (
    <>
      { isLoading && <Loader active inline="centered" /> }
      { isCompleted && (
        <div className="tourscannerPage mtContainer">
          <div>
            <Header />
            <div>
              <Tourscanner config={tsConfig} />
            </div>
          </div>
          <div>
            <Footer visibleOldVersionLink={false} />
          </div>
        </div>
      ) }
    </>
  );
};

export default PublicOfferPage;
